import { FC, SVGAttributes } from "react";
import { LinerGradient } from "../../components/atoms/LinerGradient";

interface Props extends SVGAttributes<SVGAElement> {
  variant?: "default" | "mypage";
}

export const ArrowIcon: FC<Props> = ({ className, variant = "default" }) => {
  if (variant === "mypage") {
    return (
      <svg
        width="8px"
        height="16px"
        viewBox="0 0 8 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <title>Caret left</title>
        <g
          id="user"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="マイページ"
            transform="translate(-342.000000, -788.000000)"
            fill="#838D9B"
          >
            <g
              id="Caret-left"
              transform="translate(346.000000, 796.000000) scale(-1, 1) translate(-346.000000, -796.000000) translate(342.000000, 787.000000)"
            >
              <g transform="translate(0.000000, 0.568831)" id="Path">
                <path d="M7.2404,0.773574118 C7.63093333,1.25598118 7.63093333,2.03813647 7.2404,2.52054353 L2.61426667,8.23529412 L7.2404,13.9500941 C7.63093333,14.4325176 7.63093333,15.2145412 7.2404,15.6969647 C6.84986667,16.1793882 6.2168,16.1793882 5.82626667,15.6969647 L0.492893333,9.10872941 C0.102373333,8.62630588 0.102373333,7.84428235 0.492893333,7.36185882 L5.82626667,0.773574118 C6.2168,0.291167059 6.84986667,0.291167059 7.2404,0.773574118 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        width={10}
        height={16}
        viewBox="0 0 10 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <title>Caret left</title>
        <defs>
          <LinerGradient id="ArrowIcon" />
        </defs>
        <g
          id="user"
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="チャットページ"
            transform="translate(-18.000000, -92.000000)"
            fill="url(#ArrowIcon)"
          >
            <g id="Caret-left" transform="translate(18.000000, 91.000000)">
              <g transform="translate(0.333333, 0.666667)" id="Path">
                <path d="M9.0505,0.782783333 C9.53866667,1.27093333 9.53866667,2.0624 9.0505,2.55055 L3.26783333,8.33333333 L9.0505,14.1161667 C9.53866667,14.6043333 9.53866667,15.3956667 9.0505,15.8838333 C8.56233333,16.372 7.771,16.372 7.28283333,15.8838333 L0.616116667,9.21716667 C0.127966667,8.729 0.127966667,7.93766667 0.616116667,7.4495 L7.28283333,0.782783333 C7.771,0.294633333 8.56233333,0.294633333 9.0505,0.782783333 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
};
